<template>
  <div>
    <form class="md:flex md:align-top" @submit.prevent="handleSubmit">
      <div
        class="mb-16 grid flex-1 grid-cols-2 gap-16 overflow-hidden md:grid-cols-3 lg:grid-cols-4"
        :class="{ 'max-h-56': !shouldShowAllFilters }"
      >
        <RevInputSelect
          id="market"
          v-model="values.market"
          :label="i18n(translations.market)"
          :options="marketOptions"
        />

        <RevInputSelect
          id="categoryId"
          v-model="values.categoryId"
          :label="i18n(translations.categoryId)"
          :options="categoryOptions"
        />

        <RevInputText
          id="sku"
          v-model="values.sku"
          :label="i18n(translations.sku)"
          type="text"
        />

        <RevInputText
          id="priceDifference"
          v-model="values.priceDifference"
          :label="i18n(translations.priceDifference)"
          type="text"
        />
      </div>

      <div class="ml-16">
        <RevButton type="submit" variant="primary" @click="handleSubmit">
          {{ i18n(translations.applyFilters) }}
        </RevButton>
        <RevLink class="ml-16" type="button" @click="handleReset">
          {{ i18n(translations.resetFilters) }}
        </RevLink>
      </div>
    </form>

    <div class="mb-56 lg:hidden">
      <RevButton size="small" variant="secondary" @click="handleToggleMore">
        <template v-if="shouldShowAllFilters">
          {{ i18n(translations.showLessFilters) }}
        </template>
        <template v-else>
          {{ i18n(translations.showMoreFilters) }}
        </template>
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { type Option, RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevLink } from '@ds/components/Link'

import translations from '../Filters.translations'
import type { FilterValues } from '../Filters.types'
import { getInitialValues } from '../Filters.utils'

const emit = defineEmits(['submit'])
const props = defineProps<{
  initialValues: FilterValues
  marketOptions: Option[]
  categoryOptions: Option[]
}>()

const i18n = useI18n()
const values = ref({ ...props.initialValues })
const shouldShowAllFilters = ref(false)

function handleToggleMore() {
  shouldShowAllFilters.value = !shouldShowAllFilters.value
}

function handleReset() {
  values.value = getInitialValues()
  emit('submit', values.value)
}
function handleSubmit() {
  emit('submit', values.value)
}
</script>
